import React, { useState } from 'react';
import { Modal, TextField, Button, Typography, Grid, Box } from '@mui/material';

interface CreateDepartmentModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (newDepartment: string) => void;
}

const CreateDepartmentModal: React.FC<CreateDepartmentModalProps> = ({
  open,
  onClose,
  onCreate
}) => {
  const [newDepartment, setNewDepartment] = useState('');
  const [error, setError] = useState('');

  const handleCreate = () => {
    if (!newDepartment.trim()) {
      setError('New Department is required');
    } else {
      onCreate(newDepartment);
      setNewDepartment('');
      setError('');
      onClose();
    }
  };

  const handleClose = () => {
    setNewDepartment('');
    setError('');
    onClose();
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    p: 3,
    borderRadius: 2,
    boxShadow: 24,
    width: { xs: 300, sm: 400, lg: 500 },
    border: 'none',
    outline: 'none',
    '&:focus': {
      outline: 'none'
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Create New Department
            </Typography>
            <TextField
              label="New Department"
              fullWidth
              value={newDepartment}
              onChange={(e) => setNewDepartment(e.target.value)}
              margin="normal"
              error={!!error}
              helperText={error}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              fullWidth
            >
              Close
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreate}
              fullWidth
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CreateDepartmentModal;
